var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilterSelected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4040_17716)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 24C13.7836 24 13.5731 23.9298 13.4 23.8L9.39998 20.8C9.27579 20.7069 9.17498 20.5861 9.10555 20.4472C9.03613 20.3084 8.99998 20.1552 8.99998 20V14.38L1.98398 6.487C1.4857 5.92488 1.16036 5.23082 1.04706 4.48823C0.933761 3.74565 1.03732 2.98615 1.3453 2.30101C1.65328 1.61588 2.15257 1.03426 2.78316 0.626066C3.41375 0.217873 4.14881 0.000474419 4.89998 0L19.1 0C19.8511 0.000881051 20.586 0.218639 21.2163 0.627107C21.8466 1.03557 22.3456 1.61737 22.6533 2.30259C22.9609 2.9878 23.0641 3.74727 22.9506 4.48975C22.837 5.23222 22.5114 5.9261 22.013 6.488L15 14.38V23C15 23.2652 14.8946 23.5196 14.7071 23.7071C14.5196 23.8946 14.2652 24 14 24Z",
    fill: "#409544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4040_17716"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSelected);
export default __webpack_public_path__ + "static/media/filter-selected.94e9fd0d759eb0a72850741c839b832f.svg";
export { ForwardRef as ReactComponent };